import { deburr, snakeCase } from 'lodash';

export function sanitizeFilename(filename, extension) {
  return `${snakeCase(deburr(filename))}.${extension}`;
}
